import ReactDOM from 'react-dom/client';

//
import App from './App';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<App />);

// Older POS releases registered a root-scoped service worker that cached the
// app shell indefinitely. Remove it and its caches so links opened from email
// cannot boot a stale bundle that does not know about newer public routes.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => Promise.all(
        registrations
          .filter((registration) => registration.active?.scriptURL.endsWith('/sw.js'))
          .map((registration) => registration.unregister())
      ))
      .catch(() => {});
  });
}

if ('caches' in window) {
  window.caches.keys()
    .then((cacheNames) => Promise.all(
      cacheNames
        .filter((cacheName) => cacheName.startsWith('cayenne-pos-'))
        .map((cacheName) => window.caches.delete(cacheName))
    ))
    .catch(() => {});
}

// If you want to enable client cache, register instead.

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
